import Styles from './UploadsDrawer.module.scss'
import { MediaFile } from '../MediaFile'
import { UnsplashImg, useUnsplashPhotos } from '../useUnsplashPhotos'
import { insertImage } from '../insertImage'
import { useCompleteDesignAction } from '../../utils/useCompleteDesignAction'
import { useRootStore } from 'stores/RootStore'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { DesignActionType } from 'types'
import { useState } from 'react'
import { useDebounce } from 'hooks/useDebounce'
import { Text } from 'blaze-ui/Text/Text'
import { SearchInput } from './components/SearchInput'
import { Button } from 'blaze-ui/Button'
import { createBackground } from 'components/Design/BackgroundsTab/createBackground'
import { useUploadsTab } from '../UploadsTabContext'

export const StockPhotosPanel = () => {
  const editor = useEditor()
  const [query, setQuery] = useState('')
  const debouncedQuery = useDebounce(query, 500)
  const { results, isLoading, showNoResults, handleShowMore, currentPage, maxPage } = useUnsplashPhotos({
    query: debouncedQuery,
    initialCount: 24,
  })
  const completeActionMutation = useCompleteDesignAction()
  const { drawersStore } = useRootStore()
  const { forBackground } = useUploadsTab()
  const hasNextPage = currentPage < maxPage

  const handleOnPress = (result: UnsplashImg) => {
    if (forBackground && result.width && result.height) {
      createBackground(editor, {
        src: result.regular,
        w: result.width,
        h: result.height,
        mimeType: 'image/png',
      })
      drawersStore.resetSnap()

      return
    }

    insertImage(editor, {
      id: result.regular,
      source_url: result.regular,
      mime_type: 'image/png',
      width: result.width,
      height: result.height,
      variants: [],
    })
    completeActionMutation.mutate({ action: DesignActionType.CoreImage })
    drawersStore.closeDrawer()
  }

  return (
    <div>
      <div className={Styles.sectionContainer}>
        <SearchInput value={query} onChange={setQuery} />
        {showNoResults && <Text variant="largeList">No results found for {query}.</Text>}
        <div className={Styles.groupItems}>
          {results.map((result, index) => (
            <div key={index} className={Styles.mediaFileContainer}>
              <MediaFile
                key={result.thumb}
                aria-label="Add this photo to the canvas"
                src={result.thumb}
                file={{
                  id: result.regular,
                  source_url: result.regular,
                  mime_type: 'image/png',
                  width: result.width,
                  height: result.height,
                  variants: [],
                  title: result.regular,
                }}
                onPress={() => handleOnPress(result)}
              />
            </div>
          ))}
        </div>
      </div>
      {!!debouncedQuery.length && hasNextPage && !isLoading && (
        <div className={Styles.seeMoreButton}>
          <Button fullWidth variant="tertiary" size="lg" onPress={handleShowMore}>
            See more
          </Button>
        </div>
      )}
    </div>
  )
}
